import React from "react"
import ZdqConnectorStatus from "../../components/ZdqConnectorStatus"
import { SQL_SERVER } from "../../Constants"

function ZdqSqlServerConnectorStatus() {
    return <ZdqConnectorStatus vendor={SQL_SERVER}></ZdqConnectorStatus>
}

export default ZdqSqlServerConnectorStatus